<template>
  <div class="horizontalMenu d-flex justify-center">
    <ul class="gap-1 horizontal-navbar">
      <li
        v-for="(item, i) in sidebarMenu"
        :key="i"
        class="navItem">
        <NavItem :item="item" />
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import { shallowRef } from 'vue';
import HorizontalItems, { type Menu } from './horizontalItems';
import NavItem from './NavItem.vue';

const sidebarMenu = shallowRef<Menu[]>(HorizontalItems);

defineExpose({ sidebarMenu });
</script>
